export enum CustomerType {
    NEW = 'NEW',
    EXISTING = 'EXISTING',
    PROVIDER_CHANGE = 'PROVIDER_CHANGE',
}
